import { render, staticRenderFns } from "./UpdateEmergencyLocationModal.vue?vue&type=template&id=18a93932&"
import script from "./UpdateEmergencyLocationModal.vue?vue&type=script&lang=js&"
export * from "./UpdateEmergencyLocationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports